// React
import React, { useEffect, useRef, useState } from "react";

// Libraries
import PropTypes from "prop-types";
import { Loader } from "semantic-ui-react";
import { isEmpty } from "lodash";
import ReactPlayer from "react-player/lazy";

// Redux
import { connect } from "react-redux";
import downloadFile from "@Actions/downloads";

// Utils
import { isRemoteMediaUri } from "@Utils";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const VideoContent = ({ dispatch, item }) => {
	const [isDownloading, setIsDownloading] = useState(false);
	const [fileUri, setFileUri] = useState(null);
	const cachedFileUriRef = useRef(null);

	useEffect(() => {
		const { uri } = item;
		let cancelled = false;

		(async () => {
			if (cachedFileUriRef.current) {
				setFileUri(cachedFileUriRef.current);
				setIsDownloading(false);
				return;
			}

			if (isRemoteMediaUri(uri)) {
				setIsDownloading(true);
				const file = await dispatch(downloadFile({ uri }));
				if (cancelled) return;
				if (file) {
					cachedFileUriRef.current = file;
					setFileUri(file);
				}
				setIsDownloading(false);
				return;
			}

			setFileUri(uri);
			setIsDownloading(false);
		})();

		return () => {
			cancelled = true;
		};
	}, [item.id, item.uri, dispatch]);

	useEffect(() => {
		return () => {
			if (cachedFileUriRef.current) {
				URL.revokeObjectURL(cachedFileUriRef.current);
				cachedFileUriRef.current = null;
			}
		};
	}, [item.id]);

	return (
		<>
			{isDownloading && <Loader inline active size="large" />}
			{!isDownloading && <ReactPlayer controls url={fileUri} height="100%" width="100%" />}
			{!isEmpty(item.text) && (
				<Text className={styles.text} withMarkdown>
					{item.text}
				</Text>
			)}
		</>
	);
};

VideoContent.propTypes = {
	dispatch: PropTypes.func,
	item: PropTypes.object,
};

export default connect()(VideoContent);
